import * as React from 'react';
export const createComponentThatRendersItsChildren = (displayName) => {
    const Element = ({ children }) => typeof children === 'string'
        ? React.createElement('div', {}, children)
        : children;
    Element.displayName = displayName;
    return Element;
};
//# sourceMappingURL=createComponentThatRendersItsChildren.js.map